import { render, staticRenderFns } from "./SingleScopeEmissionForThreeYears.vue?vue&type=template&id=010b8b16&scoped=true"
import script from "./SingleScopeEmissionForThreeYears.vue?vue&type=script&lang=js"
export * from "./SingleScopeEmissionForThreeYears.vue?vue&type=script&lang=js"
import style0 from "./SingleScopeEmissionForThreeYears.vue?vue&type=style&index=0&id=010b8b16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010b8b16",
  null
  
)

export default component.exports